import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=54256c78&"
import script from "./PrimaryButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryButton.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports